module.exports = __webpack_public_path__ + "media/img/aconitas-icon-125a7f643544e73f2a966c7da7063ccb.png";